import React, { useState } from 'react'
import styled from 'styled-components'

import { FooterElement, SectionTitle } from '@Components/Footer/styled'
import { up } from '@Globals/Style/breakpoints'
import { useTranslation } from '@Globals/Translations'

import { NewsletterSubscribed } from './NewsletterSubscribed'
import { NewsletterSubscriptionForm } from './NewsletterSubscriptionForm'

const StyledNewsletter = styled(FooterElement)`
  order: 3;

  ${up('tablet')} {
    order: 4;
  }
`

export const Newsletter = () => {
  const { t } = useTranslation()
  const [newsletterFormSubmitted, setFormSubmitted] = useState(false)

  return (
    <StyledNewsletter>
      <SectionTitle>{t('footer:JOIN_TRIBE_TITLE_QUESTION')}</SectionTitle>
      <p>{t('footer:JOIN_TRIBE')}</p>
      {newsletterFormSubmitted
        ? (
          <NewsletterSubscribed />
        )
        : (
          <NewsletterSubscriptionForm onSubmit={() => setFormSubmitted(true)} />
        )}
    </StyledNewsletter>
  )
}
